<template>
  <div>
  <div v-for="indexpage in 2">
        <page size="A4" class="aligncenter fontweight700" v-for="index in datashowAll.length" >
          <div class="aligncenter" style="height:285px;">
            <!-- <div class="rowprpo ">
                    <div class="col-md-6report"></div>
                    <div class="col-md-6report">
                      <p class="alignright  colprpo mr30prpo mt30">
                        Page : {{ index }}
                      </p>
                    </div>
                  </div> -->
                  <div style="min-height:188px;">
            <div class="rowprpo mr30prpo mt30">
              <div class="col-md-8report"></div>
              <div class="col-md-4report">
                <h5 class="alignright colprpo ">
                  {{ indexpage == 1? "ORIGINAL":"COPY" }}
                </h5>
              </div>
            </div>
            <div class="rowprpo aligncenter ">
              <div class="col-md-12report mt-30prpo wordspacingsummary">
                <h3>
                  {{ print_header.com_title }}
                </h3>
              </div>
            </div>
            <div class="rowprpo aligncenter ">
              <div class="col-md-12report wordspacingsummary">
                <h4>
                  {{ print_header.com_name }}
                </h4>
              </div>
            </div>
            <!-- <div class="rowprpo  aligncenter fontsize10">
              <div class="col-md-12report">
                {{ print_header.com_eng_2 }}
              </div>
            </div> -->
            <div class="rowprpo mr30prpo">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo ">
                    No : {{ print_header.inv_id }}
                  </h5>
                </div>
              </div>
            <div class="rowprpo  aligncenter">
              <div class="col-md-12report mt-20prpo">
                <h4>
                  {{ print_header.inv_company_name_th }}
                </h4>
              </div>
            </div>
            <div class="rowprpo  aligncenter  fontsize10 fixonerownoheight">
              <div class="col-md-12report aligncenter">
                {{ print_header.inv_company_branch }}
              </div>
            </div>

            <div style="text-align:-webkit-center;">
            <div class="rowprpo  aligncenter  fontsize10 width50 fixthreerownoheight">
              <div class="col-md-12report aligncenter">
                {{ print_header.inv_company_address }} 
              </div>
            </div>
          </div>
            <!-- <div class="rowprpo  aligncenter  fontsize10">
              <div class="col-md-12report">
                {{ print_header.com_add_city }}
              </div>
            </div>
            <div class="rowprpo  aligncenter  fontsize10">
              <div class="col-md-12report">
                {{ print_header.com_add_country }}
              </div>
            </div> -->
            <div class="rowprpo  aligncenter  fontsize10 fixonerownoheight">
              <div class="col-md-12report aligncenter">
                Tel :  {{ print_header.inv_company_tel }}
              </div>
            </div>
            <!-- <div class="rowprpo  aligncenter  fontsize10">
              <div class="col-md-12report">
                {{ print_header.com_add_fax }}
              </div>
            </div> -->
            <div class="rowprpo  aligncenter  fontsize10 fixonerownoheight">
              <div class="col-md-12report aligncenter">
                E-MAIL : {{ print_header.inv_company_email }}
              </div>
            </div>
            <div class="rowprpo  aligncenter  fontsize10 fixonerownoheight">
              <div class="col-md-12report aligncenter">
                TAX ID. No. 
                {{
                  print_header.inv_tax_id
                    ? print_header.inv_tax_id
                    : "-"
                }}
              </div>
            </div>
          </div>
            <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
            >
              <v-divider
                style="margin-top: 5px;"
                class="borderwidththin"
              ></v-divider>
            </div>
          

            <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize12"
            >
              <div class="col-md-1report textalignleft ">
                To/ถึง :
              </div>
              <div class="col-md-6report textalignleft fixonerow">
                {{
                  print_header.customer_name ? print_header.customer_name : "-"
                }}
              </div>
              <div class="col-md-5report">
                <div class="rowprpo">
                  <div class="col-md-4report textalignleft fontsize12">
                   Invoice Date/วันที่ :
                  </div>
                  <div
                    class="col-md-8report textalignleft fixonerow"
                  >
                    {{
                      print_header.invoice_date
                        ? print_header.invoice_date
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize12 mt-5prpo"
            >
              <div class="col-md-1report">
                <h5></h5>
              </div>
              <div class="col-md-5report textalignleft fixthreerow">
                {{ print_header.addressall ? print_header.addressall : "-" }}
              </div>
              <div class="col-md-1report"></div>
              <div class="col-md-5report">
                <div class="rowprpo">
                  <div class="col-md-6report55 textalignleft ">
                    Duedate / รอบระยะเวลา :
                  </div>
                  <div class="col-md-6report45 textalignleft fixonerow" style="margin-left:-40px">
                    {{
                      print_header.period_cover
                        ? print_header.period_cover
                        : "-"
                    }}
                  </div>
                </div>

                <div class="rowprpo">
                  <div class="col-md-2report20 textalignleft ">
                    Attention :
                  </div>
                  <div class="col-md-10report80 textalignleft fixtworow">
                    {{ print_header.attention ? print_header.attention : "-" }}
                      {{
                    print_header.contact_position
                      ? "/ "+ print_header.contact_position
                      : ""
                  }}
                  </div>
                </div>
              </div>
            </div>

            <!-- <div
                  class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
                >
                  <div class="col-md-2report textalignleft">
                    Attention :
                  </div>
                  <div
                    class="col-md-6report textalignleft  ml-40prpo fixonerow"
                  >
                    {{
                      print_header.customer_contact_name
                        ? print_header.customer_contact_name
                        : "-"
                    }}
                  </div>
                  <div class="col-md-2report">
                    <h5></h5>
                  </div>
                  <div class="col-md-2report textalignleft">
                    <h5></h5>
                  </div>
                </div> -->

            <!-- <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
            >
              <div class="col-md-1report textalignleft"></div>
              <div class="col-md-6report textalignleft fixonerow">
                {{
                  print_header.province_invoice
                    ? print_header.province_invoice
                    : "-"
                }}
                ,
                {{
                  print_header.zipcode_invoice
                    ? print_header.zipcode_invoice
                    : "-"
                }}
              </div>
              <div class="col-md-2report">
                <h5></h5>
              </div>
              <div class="col-md-2report textalignleft">
                <h5></h5>
              </div>
            </div> 
            <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
            >
              <div class="col-md-1report textalignleft"></div>
              <div class="col-md-6report textalignleft fixonerow">
                {{
                  print_header.country_invoice
                    ? print_header.country_invoice
                    : "-"
                }}
              </div>
              <div class="col-md-2report">
                <h5></h5>
              </div>
              <div class="col-md-2report textalignleft">
                <h5></h5>
              </div>
            </div>
            -->

            <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize12 mt-5prpo"
            >
              <div class="col-md-1report textalignleft">
                TAX ID :
              </div>
              <div class="col-md-6report textalignleft fixonerow">
                {{
                  print_header.customer_taxid
                    ? print_header.customer_taxid
                    : "-"
                }} /  {{
                    print_header.customer_branch
                      ? print_header.customer_branch
                      : "-"
                  }}
              </div>
              <div class="col-md-5report">
                <div class="rowprpo">
                  <div class="col-md-3report27">
                    Document Ref. :
                  </div>
                  <div class="col-md-9report73 textalignleft fixonerow">
                    {{ print_header.docref ? print_header.docref : "-" }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
            >
              <!-- <v-divider class="borderwidththin"></v-divider> -->
            </div>
          </div>

          <div
            class="rowprpo caption  ml30prpo mr30prpo"
            style="margin-top:10px"
          >
            <table class="captionhtable ">
              <tr>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width40 thborder-top thborder-left fontsize13 captionhtable fontweight700"
                >
                  <span class="aligncenter">Description / รายการ </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width10 thborder-top thborder-left thborder-right fontsize13 captionhtable fontweight700"
                >
                  <span class="aligncenter">Amount / จำนวนเงิน </span>
                </th>
              </tr>
            </table>

            <table class="captionhtable " :style="{height:heighttabledetail}">
                <tr
                  v-for="(data, i) in datashowAll[index - 1]"
                  style="height:20px;"
                >
                  <td
                    style="position: relative;"
                    scope="colgroup"
                    class="textalignleft width80 caption prborderbottomsumpo tdborder-left fontsize14 paddingleftintable fontweight700"
                  >
                    <span
                      v-if="
                        haveSO == false &&
                          i == 0 &&
                          datashowAlltimesheet.length > 0
                      "
                      class="fixtworow fontsize14 textalignleft titledatadetailintable"
                    >
                      <br />
                      Professional fee</span
                    >
                    <span
                      class="fixtworow fontsize14"
                      v-if="data.first_item == 1"
                    >
                      <!-- <span
                      class="titledatadetailintable"
                      v-if="data.report_type == 'SO'"
                      >Sales Order</span> -->
                      <span
                        class="titledatadetailintable "
                        v-if="data.report_type == 'ADMIS'"
                        ><br />Miscellaneous Disbursement:</span
                      >
                      <!-- <span
                      class="titledatadetailintable"
                      v-else-if="data.report_type == 'MIS'"
                      >Miscellaneous</span
                    > -->
                    </span>
                    <span
                      v-if="
                        data.amount_morethen_zero == 'yes' 
                      "
                      class="fixonerow fontsize14 textalignleft titledatadetailintable"
                    >
                      <br /></span>

                    <span class="textalignleft" style="white-space: pre-line">  {{ data.report_desc }} </span>
                    <span
                      v-if="
                        data.solastdata == 'SOlastindex' &&
                          haveSO == true &&
                          datashowAlltimesheet.length > 0
                      "
                      class="fixtworow fontsize14 textalignleft titledatadetailintable"
                    >
                      <br />
                      Professional fee</span
                    >
                  </td>
                  <td
                    style="position: relative;"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize14 fontweight700"
                  >
                    <span
                      class="width100 textalignright paddingrightintable"
                      style="vertical-align: bottom;position:absolute;bottom:0px;"
                    >
                    
                    <span
                        class="fixonerow fontsize14"
                        v-if="
                          data.amount_morethen_zero == 'yes' 
                        "
                      >
                        <br />
                      </span>
                      <span
                        class="fixtworow fontsize14"
                        v-if="
                          haveSO == false &&
                            i == 0 &&
                            datashowAlltimesheet.length > 0
                        "
                      >
                        <br />
                        <span class="textalignright  alignright">
                          {{
                            print_header.ts_total.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </span>
                      <span
                        class="fixtworow fontsize14"
                        v-if="data.first_item == 1"
                        ><br /><br />
                      </span>
                      <span v-if="data.report_amount">
                      {{
                        data.report_amount.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                      </span>                    
                     
                      
                      <span
                        class="fixtworow fontsize14"
                        v-if="
                          data.solastdata == 'SOlastindex' &&
                            haveSO == true &&
                            datashowAlltimesheet.length > 0
                        "
                      >
                        <br />
                        <span class="textalignright  alignright">
                          {{
                            print_header.ts_total.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                  ></td>
                  <td
                    scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom"
                  ></td>
                </tr>
              </table>
          </div>
          <div class="footerprpo">
              <div class="rowprpo captiontotal  ml30prpo mr30prpo">
                <table
                  class="captionhtable "
                  v-if="index == datashowAll.length"
                >
                  <tr>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal prborderbottomsumpo tdborder-left   width80 tdborder-bottom paddingleftintable fontsize14"
                    >
                      <h4 class="textalignleft">
                        <span> Sub Total / รวมเป็นเงิน</span>
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal prborderbottomsumpo tdborder-left   width20 tdborder-right tdborder-bottom paddingrightintable fontsize14"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.sub_total
                              ? print_header.sub_total.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "0.00"
                          }}
                          <span class="fontsize13">{{ showcurrency }}</span>
                        </h4></span
                      >
                    </td>
                  </tr>

                  <tr>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal prborderbottomsumpo tdborder-left   width80 tdborder-bottom paddingleftintable fontsize14"
                    >
                      <h4 class="textalignleft">
                        <span>
                          Less Withholding Tax / ภาษีเงินได้ หัก ณ ที่จ่าย ({{
                            print_header.wth_rate
                              ? print_header.wth_rate
                              : "0.00"
                          }}
                          %)</span
                        >
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal prborderbottomsumpo tdborder-left   width20 tdborder-right tdborder-bottom paddingrightintable fontsize14"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.wth_rate_amount
                              ? print_header.wth_rate_amount.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }}
                          <span class="fontsize13">{{ showcurrency }}</span>
                        </h4></span
                      >
                    </td>
                  </tr>

                  <tr v-if="!checklawoffice">
                    <td
                      scope="colgroup"
                      class="textalignleft width100 captiontotal prborderbottomsumpo tdborder-left   tdborder-bottom paddingleftintable fontsize14"
                    >
                      <h4>
                        <span class="textalignleft">
                          Value Added Tax / ภาษีมูลค่าเพิ่ม ({{
                            print_header.tax_rate
                              ? print_header.tax_rate
                              : "0.00"
                          }}
                          %)</span
                        >
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft width100 captiontotal prborderbottomsumpo tdborder-left  tdborder-right tdborder-bottom paddingrightintable fontsize14"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.tax_rate_amount
                              ? print_header.tax_rate_amount.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }}
                          <span class="fontsize13">{{ showcurrency }}</span>
                        </h4></span
                      >
                    </td>
                  </tr>

                  <tr>
                    <td
                      scope="colgroup"
                      class="textalignleft width100 captiontotal prborderbottomsumpo tdborder-left   paddingleftintable fontsize14"
                    >
                      <h4 class="textalignleft">
                        <span> Grand Total / ยอดรวม</span><br />
                        <!-- <span
                          class="fixonerowcenter fontsize12"
                          style="display: table;margin: 0px auto 0px auto;"
                          >({{ textamount_total_en }}) {{ showcurrency }}</span
                        > -->
                        <!-- background-color:#dedbdb; -->
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft width100 captiontotal prborderbottomsumpo tdborder-left  tdborder-right tdborder-bottom paddingrightintable fontsize14"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_header.amount_total
                              ? print_header.amount_total.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }}
                          <span class="fontsize13">{{ showcurrency }}</span>
                        </h4></span
                      >
                    </td>
                  </tr>
                  <tr>
                      <td
                        colspan="2"
                        scope="colgroup"
                        class="textalignleft width100 captiontotal prborderbottomsumpo tdborder-left   tdborder-bottom paddingleftintable fontsize14 tdborder-bottom tdborder-right"
                      >
                        <h4 class="textalignleft" v-if="check_cus_name">
                          <span 
                            class="fixonerowcenter"
                            style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                            >({{ textamount_total_en }}) {{ showcurrency }}</span
                          >
                        </h4>
                        <h4 class="textalignleft" v-else>
                          <span v-if="showcurrency != 'THB'"
                            class="fixonerowcenter"
                            style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                            >({{ textamount_total_en }}) {{ showcurrency }}</span
                          >
                          <span v-else
                            class="fixonerowcenter"
                            style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                            >({{ textamount_total_en }})</span
                          >

                        </h4>
                      </td>
                    </tr>
                </table>

                <!-- <div class="rowprpo aligncenter mt30">
                  <div class="col-md-12report aligncenter">
                    <div
                      class="aligncenter borderblack borderblockpr fontsize10 "
                    >
                      <div class="  aligncenter col-md-12report mt20">
                        <div class="col-md-12report">
                          _________________________________________
                        </div>
                        <div class="col-md-12report">
                          Authorized Signature / ผู้มีอำนาจลงนาม
                        </div>
                        <div class="col-md-12report">
                          Date / วันที่ _____________________________
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="rowprpo  aligncenter col-md-12report fontsize10">
                  <div class="col-md-12report fontweight700">
                    Please send us a certificate of above withholding income tax
                    issued to our firm together with your payment
                  </div>
                </div>
                <div
                  class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo"
                >
                  <div class="col-md-12report fontweight700">
                    โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชําระเงิน
                  </div>
                </div>
              </div>
            </div>
        </page>

        <!-- additional note page -->
        <!-- <page
          v-if="print_header.additional_top || print_header.additional_bottom"
          size="A4"
          class="aligncenter"
        >
          <div class="aligncenter">
            <div class="rowprpo mr30prpo mt30">
              <div class="col-md-8report"></div>
              <div class="col-md-4report">
                <h5 class="alignright colprpo ">
                  No : {{ print_header.inv_id }}
                </h5>
              </div>
            </div>
            <div class="rowprpo aligncenter ">
              <div class="col-md-12report mt-30prpo wordspacingsummary">
                <h3>
                  {{ print_header.com_title }}
                </h3>
              </div>
            </div>
          </div>

          <div
            class="rowprpo caption  ml30prpo mr30prpo"
            style="margin-top:10px"
          >
            <table class="captionhtable ">
              <tr>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width100 thborder-top thborder-left thborder-right fontsize13 captionhtable"
                >
                  <span class="aligncenter">Additional Note </span>
                </th>
              </tr>
            </table>

            <table class="captionhtable " style="height:965px;">
              <tr
                v-if="
                  print_header.additional_top &&
                    print_header.additional_top !== ''
                "
                style="height:20px;"
              >
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width100 caption prborderbottomsumpo tdborder-left tdborder-right fontsize14 paddingleftintable"
                >
                  <span
                    v-html="print_header.additional_top"
                    class="width98 textalignleft"
                    style="vertical-align: top;position:absolute;top:0px;"
                  ></span>
                </td>
              </tr>
              <tr>
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width100 caption prborderbottomsumpo tdborder-left tdborder-right fontsize14 tdborder-bottom paddingleftintable"
                >
                  <span
                    v-if="
                      print_header.additional_bottom &&
                        print_header.additional_bottom !== ''
                    "
                    v-html="print_header.additional_bottom"
                    class="width98 textalignleft"
                    style="vertical-align: bottom;position:absolute;bottom:0px;padding-bottom: 5px;"
                  ></span>
                </td>
              </tr>
            </table>
          </div>
          <div class="footerprpo">
            <div class="rowprpo caption  ml30prpo mr30prpo">
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report fontweight700">
                  Please send us a certificate of above withholding income tax
                  issued to our firm together with your payment
                </div>
              </div>
              <div
                class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo"
              >
                <div class="col-md-12report fontweight700">
                  โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชํ
                  าระเงิน
                </div>
              </div>
            </div>
          </div>
        </page> -->

        <page
          v-if="datashowAlltimesheet.length > 0"
          v-for="indextimesheet in datashowAlltimesheet.length"
          size="A4"
          class="aligncenter"
        >
          <div class="aligncenter">
            <div class="rowprpo mr30prpo mt30">
              <div class="col-md-8report"></div>
              <div class="col-md-4report">
                <h5 class="alignright colprpo ">
                  No : {{ print_header.inv_id }}
                </h5>
              </div>
            </div>
            <div class="rowprpo aligncenter ">
              <div class="col-md-12report mt-30prpo wordspacingsummary">
                <h3>
                  {{ print_header.com_title }}
                </h3>
              </div>
            </div>
          </div>

          <div
            class="rowprpo caption  ml30prpo mr30prpo"
            style="margin-top:10px"
          >
            <table class="captionhtable ">
              <tr>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width15 thborder-top thborder-left fontsize13 captionhtable"
                >
                  <span class="aligncenter">Date / วันที่ </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width15 thborder-top thborder-left fontsize13 captionhtable"
                >
                  <span class="aligncenter">Lawyer </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width50 thborder-top thborder-left fontsize13 captionhtable"
                >
                  <span class="aligncenter">Description / รายการ </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left thborder-right fontsize13 captionhtable"
                >
                  <span class="aligncenter">Amount / จำนวนเงิน </span>
                </th>
              </tr>
            </table>

            <table class="captionhtable " style="height:965px;">
              <tr
                v-for="(datatimsheet, itimsheet) in datashowAlltimesheet[
                  indextimesheet - 1
                ]"
                style="height:20px;"
              >
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width15 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable"
                >
                  <span
                    class="width100 textalignleft"
                    style="vertical-align: top;position:absolute;top:0px;"
                  >
                    <span v-if="itimsheet == 0" class="fixonerow fontsize13"
                      ><br />
                    </span>
                    {{ datatimsheet.report_date }}</span
                  >
                </td>
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width15 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable"
                >
                  <span
                    class="width100 textalignleft"
                    style="vertical-align: top;position:absolute;top:0px;"
                  >
                    <span v-if="itimsheet == 0" class="fixonerow fontsize13"
                      ><br />
                    </span>
                    {{ datatimsheet.lawyer }}</span
                  >
                </td>
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width50 caption prborderbottomsumpo tdborder-left  fontsize14 paddingleftintable "
                >
                  <span
                    v-if="itimsheet == 0"
                    class="fixonerow fontsize14 titledatadetailintable"
                  >
                    Professional fee
                  </span>
                  <span class="textalignleft">
                    {{ datatimsheet.report_desc }}</span
                  >
                </td>
                <td
                  style="position: relative;"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize14 "
                >
                  <span
                    class="width100 textalignright paddingrightintable"
                    style="vertical-align: top;position:absolute;top:0px;"
                  >
                    <span v-if="itimsheet == 0" class="fixonerow fontsize13"
                      ><br />
                    </span>
                    {{
                      datatimsheet.report_amount.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}</span
                  >
                </td>
              </tr>
              <tr>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                ></td>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                ></td>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                ></td>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom"
                ></td>
              </tr>
            </table>
          </div>
          <div class="footerprpo">
            <div class="rowprpo caption  ml30prpo mr30prpo">
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report fontweight700">
                  Please send us a certificate of above withholding income tax
                  issued to our firm together with your payment
                </div>
              </div>
              <div
                class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo"
              >
                <div class="col-md-12report fontweight700">
                  โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชํ
                  าระเงิน
                </div>
              </div>
            </div>
          </div>
        </page>

        <page
          v-if="datashowAlltimekeeper.length > 0"
          size="A4"
          class="aligncenter"
        >
          <div class="aligncenter">
            <div class="rowprpo mr30prpo mt30">
              <div class="col-md-8report"></div>
              <div class="col-md-4report">
                <h5 class="alignright colprpo ">
                  No : {{ print_header.inv_id }}
                </h5>
              </div>
            </div>
            <div class="rowprpo aligncenter ">
              <div class="col-md-12report mt-30prpo wordspacingsummary">
                <h3>
                  {{ print_header.com_title }}
                </h3>
              </div>
            </div>
          </div>

          <div
            class="rowprpo caption  ml30prpo mr30prpo"
            style="margin-top:10px"
          >
            <table class="captionhtable ">
              <tr>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width40 thborder-top thborder-left fontsize13 captionhtable"
                >
                  <span class="aligncenter">Timekeepers </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left fontsize13 captionhtable"
                >
                  <span class="aligncenter">Rate(Baht) </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left fontsize13 captionhtable"
                >
                  <span class="aligncenter">Charge Hours </span>
                </th>
                <th
                  scope="colgroup"
                  class="prbordertop2pxhtable prborderbottom2pxhtable width20 thborder-top thborder-left thborder-right fontsize13 captionhtable"
                >
                  <span class="aligncenter">Charge Value(Baht) </span>
                </th>
              </tr>
            </table>

            <table class="captionhtable " style="height:965px;">
              <tr
                v-for="(datatimekeeper,
                indextimekeeper) in datashowAlltimekeeper"
                style="height:20px;"
              >
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width40 caption prborderbottomsumpo tdborder-left fontsize13 paddingleftintable"
                >
                  <span
                    v-if="indextimekeeper == 0"
                    class="fixonerow fontsize13 titledatadetailintable"
                  >
                    Timekeeper Details
                  </span>

                  <span class="width100 textalignleft">
                    {{ datatimekeeper.tc_name }}</span
                  >
                </td>
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left fontsize13"
                >
                  <span
                    class="width100 textalignright paddingrightintable"
                    style="vertical-align: top;position:absolute;top:0px;"
                  >
                    <span
                      v-if="indextimekeeper == 0"
                      class="fixonerow fontsize13"
                      ><br />
                    </span>
                    <span class="width100 textalignright">
                      {{ datatimekeeper.tc_rate_show }}</span
                    >
                  </span>
                </td>
                <td
                  style="position: relative;"
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left  fontsize13 "
                >
                  <span
                    class="width100 textalignright paddingrightintable"
                    style="vertical-align: top;position:absolute;top:0px;"
                  >
                    <span
                      v-if="indextimekeeper == 0"
                      class="fixonerow fontsize13"
                      ><br />
                    </span>
                    <span class="width100 textalignright">
                      {{ datatimekeeper.tc_actualchargehour_show }}</span
                    >
                  </span>
                </td>
                <td
                  style="position: relative;"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right fontsize13 "
                >
                  <span
                    class="width100 textalignright paddingrightintable"
                    style="vertical-align: top;position:absolute;top:0px;"
                  >
                    <span
                      v-if="indextimekeeper == 0"
                      class="fixonerow fontsize13"
                      ><br />
                    </span>
                    <span class="width100 textalignright">
                      {{ datatimekeeper.tc_rateChargeHour_bath_show }}</span
                    >
                    <span  v-if="indextimekeeper == datashowAlltimekeeper.length-1" class="width100 textalignright doubleunderline">
                        <br />
                        {{
                            print_header.ts_total.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          }}</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td
                  scope="colgroup"
                  class="textalignleft width40 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                ></td>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                ></td>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                ></td>
                <td
                  scope="colgroup"
                  class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom"
                ></td>
              </tr>
            </table>
          </div>
          <div class="footerprpo">
            <div class="rowprpo caption  ml30prpo mr30prpo">
              <div class="rowprpo  aligncenter col-md-12report fontsize10">
                <div class="col-md-12report fontweight700">
                  Please send us a certificate of above withholding income tax
                  issued to our firm together with your payment
                </div>
              </div>
              <div
                class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo"
              >
                <div class="col-md-12report fontweight700">
                  โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชํ
                  าระเงิน
                </div>
              </div>
            </div>
          </div>
        </page>
      </div>
    </div>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  name: "InvoiceSalseorderTab",
  props: [
    "datashowAll",
    "print_header",
    "heighttabledetail",
    "datashowAlltimesheet",
    "haveSO",
    "showcurrency",
    "check_cus_name",
    "textamount_total_en",
    "datashowAlltimekeeper",
    "checklawoffice",
  ],
  // async beforeUpdate() {
  //   if (this.datainv_h.customerid != 0) {
  //     await this.loaddataSO();
  //   } else {
  //   }
  // },
  async beforeMount() {
  
  },
  async mounted() {
    console.log(this.datashowAll)
    // this.$showLoader();
   
  },
  components: {
    SuccessDialog,
  },
  data() {
    return {
      vat_type_list:[{id:"I",name:"Include Vat"},{id:"E",name:"Exclude Vat"}],
      isdisableeditpriceperunit:true,
      inv_title_list: [],
      status_loadso: 0,
      editedIndex: -1,
      dataeditItem: {
        no: 0,
        description: "",
        unit: 0,
        item_um: "",
        PricePerUnit: 0,
        amount: 0,
      },
      dialogEdit: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,
      customer: [],
      customer_list: [],
      customer_code: "",
      customer_id: "",
      customer_name: "",
      saleorder_id: "",
      currency: "",
      tax_id: "",
      branch: "",
      invoice_address: "",
      payment_term: 0,
      vat: 0,
      po_no: "",
      attention: "",
      contact_position: "",
      vat_type:"",
      vatCal: 0,
      desserts: [],
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      editedItemadd: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      defaultItem: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      // dialogAdd: false,
      dialogSendMail: false,
      // text_color: "text-h5 green--text text-center",
      // title: "green",
      // message: "green",
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service Details",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "30%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        // {
        //   text: "Unit",
        //   value: "item_um",
        //   class: "bg-colorth texttablehcenter ",
        //   width: "10%",
        //   divider: true,
        //   align: "end",
        //   sortable: false,
        // },
        {
          text: "Price Per Unit",
          value: "PricePerUnit",
          class: "bg-colorth texttablehcenter",
          width: "14%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Total Price",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          align: "center",
          width: "13%",
          divider: true,
          sortable: false,
        },
      ],
      dialogAddSo: false,
      text_colorSo: "text-h5 green--text text-center",
      titleSo: "green",
      messageSo: "green",
    };
  },
  methods: {

    async loadCustomer() {
      let result = [];
      result = await api.getAllCustomerListactive();

      this.customer = result.data;

      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });
      this.$hideLoader();
    },

   
    async onSelectpayment() {
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      // alert(this.payment_term)
    },
    async onSelectvat() {
      this.$emit("inv_sotab_vatcus", this.vat);
      // alert(this.vat)
    },
    async onSelectpono() {
      this.$emit("inv_sotab_ponocus", this.po_no);
      // alert(this.po_no)
    },
    async onSelectattention() {
      this.$emit("inv_sotab_attentioncus", this.attention);
    },
    async onSelectcontact_position() {
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
    },
    async onSelectvat_type() {
      this.$emit("inv_sotab_vat_type", this.vat_type);
    },

    setupAlertDialog(status, titleSo, messageSo, text_colorSo) {
      this.titleSo = titleSo;
      this.messageSo = messageSo;
      this.dialogAddSo = status;
      this.text_colorSo = text_colorSo;
    },
  },

  beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}
.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}
.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}
.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}
.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}
.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}
page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}
page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}
@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}
.btnuploadfile {
  border: 2px solid;
}
.v-btn:not(.v-btn--round).v-size--default.buttonred100 {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}
.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}
h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled > b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.aligncenter {
  text-align: center;
}
.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}
.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}
.captiontotal {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8rem;
  font-family: "Roboto", sans-serif;
}
.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8;
  font-family: "Roboto", sans-serif;
}
.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}
.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}
.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}
.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}
.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}
.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}
.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}
.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}
.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}
.mt20 {
  margin-top: 20px !important;
}
.mt10 {
  margin-top: 10px !important;
}
.mt25 {
  margin-top: 25px !important;
}

.mt-20prpo {
  margin-top: -20px !important;
}
.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}
.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}
.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}
.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}
.textalignright {
  text-align: right;
}
.textaligncenter {
  text-align: center;
}
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}
.prbordertop {
  border-top: 1px solid black;
}
.prborderbottom {
  border-bottom: 1px solid black;
}
.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}
.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}
td.tdborder-top {
  border-top: 1px solid black;
}
td.tdborder-right {
  border-right: 1px solid black;
}
td.tdborder-left {
  border-left: 1px solid black;
}
td.tdborder-bottom {
  border-bottom: 1px solid black;
}
th {
  /* border: 1px solid black; */
}
th.thborder-top {
  border-top: 1px solid black;
}
th.thborder-right {
  border-right: 1px solid black;
}
th.thborder-left {
  border-left: 1px solid black;
}
th.thborder-bottom {
  border-bottom: 1px solid black;
}
.width15 {
  word-wrap: break-word;
  width: 15%;
}
.width10 {
  word-wrap: break-word;
  width: 10%;
}
.width20 {
  word-wrap: break-word;
  width: 20%;
}
.width30 {
  word-wrap: break-word;
  width: 30%;
}
.width40 {
  word-wrap: break-word;
  width: 40%;
}
.width50 {
  word-wrap: break-word;
  width: 50%;
}
.width60 {
  word-wrap: break-word;
  width: 60%;
}
.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}
.width90 {
  word-wrap: break-word;
  width: 90%;
}
.width98 {
  word-wrap: break-word;
  width: 98%;
}
.width100 {
  word-wrap: break-word;
  width: 100%;
}
@media print {
  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }
  .noprint {
    display: none;
  }
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}
footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}
header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}
.borderauto {
  border: 1px solid;
  margin: -1px;
}
.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}
.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}
.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}
.fixthreerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}
.fixonerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}
.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}
.fontsize10 {
  font-size: 10px;
}
.fontsize12 {
  font-size: 12px;
}
.fontsize13 {
  font-size: 13px;
}
.fontsize14 {
  font-size: 14px;
}

.borderwidththin {
  border-width: thin;
  border-color: darkgray;
}
.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}
.paddingleftintable {
  padding-left: 10px;
}
.paddingrightintable {
  padding-right: 10px;
}
.v-text-field.v-text-field--enclosed
  .v-text-field__details
  .cutdetailtextfield {
  padding-top: 0px;
  margin-bottom: -25px;
}
.v-application a {
  color: white;
}
.containertab {
  max-width: 100%;
  min-width: 100%;
  margin: 40px auto;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 0.9em;
  color: #888;
}
.tabs {
  overflow: hidden;
  /* margin-left: 20px; */
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 10px 24px;
  transition: background-color 0.2s;
  border: 1px solid #595959;
  /* border-right: none; */
  border-right: 1px solid #595959;
  background-color: #595959;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}
/* .tabs a:last-child {
  border-right: 1px solid #595959;
} */

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #484848;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #595959;
  /* border-radius: 10px; */
  border-radius: 0px 10px 10px 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
}

.btn-width {
  width: 120px;
}
.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.width16 {
  width: 16%;
}
.widthsubtotal {
  width: 18%;
}

.widthsubtotalG {
  width: 36%;
}

.widthplus {
  width: 4%;
}
.widthsub {
  width: 6%;
}

.widthgrandnull {
  width: 102%;
}
.widthspace {
  width: 4%;
}
.widthglessword {
  width: 60%;
}
.widthlesspersen {
  width: 12%;
}
.widthtextpersen {
  width: 8%;
}
.widthlesstotal {
  width: 16%;
}
.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}
.fontweight700 {
  font-weight:700;
}
.col-md-6report55 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 55%;
  flex: 0 0 55%;
  max-width: 55%;
}
.col-md-6report45 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 45%;
  flex: 0 0 45%;
  max-width: 45%;
}
.col-md-2report20 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
.col-md-10report80 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 80%;
  flex: 0 0 80%;
  max-width: 80%;
}
.col-md-3report27 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 27%;
  flex: 0 0 27%;
  max-width: 27%;
}
.col-md-9report73 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 73%;
  flex: 0 0 73%;
  max-width: 73%;
}
.doubleunderline{
  /* text-decoration-line: underline;
  text-decoration-style: double; */
  border-bottom: 3px double #000000;
  border-top: 1px double #000000;
  /* text-underline-offset: 4px; */
  /* padding-bottom:4px;
  height: 1px; */
}
</style>

